import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FrontEndService } from '../../../services/front-end/front-end.service';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-front-end',
  templateUrl: './front-end.component.html',
  styleUrls: ['./front-end.component.css'],
  providers: []
})
export class FrontEndComponent implements OnInit {

  newDataAvailable = false;

  paginationType = KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  stateFilterOptions: Array<{label: string, value: string | null}> = [];

  constructor(
    public srvFrontEnd: FrontEndService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {
    this.stateFilterOptions = [
      {label: '', value: null},
      {label: this.translate.instant('status.active'), value: '0'},
      {label: this.translate.instant('status.inactive'), value: '1'}
    ];
    this.translate.get(['status.active', 'status.inactive']).subscribe(t => {
      this.stateFilterOptions[1].label = t['status.active'];
      this.stateFilterOptions[2].label = t['status.inactive'];
    });
  }

  ngOnInit() {
  }

  refresh() {
    this.newDataAvailable = true;
  }

  showAddOrEditDialog(data): void {
    if (data == null) {
      this.srvFrontEnd.frontEndEditing = null;
      this.router.navigate(['/front-end/form']);
    } else {
      this.srvFrontEnd.frontEndEditing = data;
      this.router.navigate(['/front-end/form', data.id]);
    }
  }

  deleteFrontEnd(record): void {
    this.srvFrontEnd.delete(record).subscribe(() => {
      this.refresh();
    });
  }

  recoverFrontEnd(record): void {
    this.srvFrontEnd.recover(record).subscribe(() => {
      this.refresh();
    });
  }

  confirmDelete(record): void {
    this.translate.get(['kontable.delete', 'kontable.removeConfirmation']).subscribe(translations => {
      this.confirmationService.confirm({
        header: `${translations['kontable.delete']}!`,
        message: translations['kontable.removeConfirmation'],
        accept: () => this.deleteFrontEnd(record)
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/front-end/front-end.component.ts